import React from 'react';

interface ContractorDetailStatsProps {
  yearsExperience: number;
  projectSize: string;
  completionRate: number;
  isMobile?: boolean;
  isDesktop?: boolean;
}

const ContractorDetailStats: React.FC<ContractorDetailStatsProps> = ({
  yearsExperience,
  projectSize,
  completionRate,
  isMobile,
  isDesktop,
}) => {
  if (isMobile) {
    return (
      <section className="px-container-margin mt-stack-lg md:hidden">
        <div className="grid grid-cols-3 gap-gutter bg-white p-4 rounded-xl shadow-sm border border-outline-variant">
          <div className="flex flex-col items-center border-r border-outline-variant last:border-r-0">
            <span className="font-headline-sm text-headline-sm text-primary">{yearsExperience}</span>
            <span className="font-label-md text-label-md text-outline">Years Exp.</span>
          </div>
          <div className="flex flex-col items-center border-r border-outline-variant last:border-r-0">
            <span className="font-headline-sm text-headline-sm text-primary">{projectSize}</span>
            <span className="font-label-md text-label-md text-outline">Project Size</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="font-headline-sm text-headline-sm text-primary">{completionRate}%</span>
            <span className="font-label-md text-label-md text-outline">Completion</span>
          </div>
        </div>
      </section>
    );
  }

  if (isDesktop) {
    return (
      <div className="pt-4 border-t border-outline-variant space-y-stack-md">
        <div className="flex justify-between">
          <span className="text-on-surface-variant font-label-md">Years Exp.</span>
          <span className="font-label-bold">{yearsExperience} Years</span>
        </div>
        <div className="flex justify-between">
          <span className="text-on-surface-variant font-label-md">Project Size</span>
          <span className="font-label-bold">{projectSize}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-on-surface-variant font-label-md">Completion %</span>
          <span className="font-label-bold text-emerald-600">{completionRate}%</span>
        </div>
      </div>
    );
  }

  return null;
};

export default ContractorDetailStats;